import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { ClearCurrentTaskId, SetCurrentTaskId } from './../../states/tasks-state/tasks.actions';
import { TasksState } from './../../states/tasks-state/tasks.state';

@Component({
  selector: 'app-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss']
})
export class TasksComponent implements OnInit, OnDestroy {
  
  public showDetails = false;
  private subs = new Array<Subscription>();
  
  public constructor(
    private route: ActivatedRoute,
    private location: Location,
    private store: Store) {}


  public ngOnInit(): void {
    const urlTaskId = this.route.snapshot.paramMap.get('id');
    const urlCustomerId = this.route.snapshot.paramMap.get('customerId');
    const urlStatus = this.route.snapshot.paramMap.get('status');
    const urlLaboratoryId = this.route.snapshot.paramMap.get('laboratoryId');
    const urlStartDate = this.route.snapshot.paramMap.get('startDate');
    const urlEndDate=this.route.snapshot.paramMap.get('endDate');
    
    if (urlTaskId) {
      this.store.dispatch(new SetCurrentTaskId(urlTaskId));
    }

    this.subs.push(this.store.select(TasksState.getSelectedTaskId).subscribe(taskId =>
      {
        if (urlLaboratoryId && urlStatus && urlStartDate && urlEndDate) {
          this.location.replaceState('tasks;laboratoryId=' + urlLaboratoryId + ';status=' + urlStatus +
          ';startDate=' + urlStartDate + ';endDate=' + urlEndDate);

          this.showDetails = taskId !== '';
        }
        else if (taskId !== ''){
          this.location.replaceState('tasks/' + taskId);
          this.showDetails = true;
        }
        else if (urlCustomerId){
          this.location.replaceState('tasks;customerId=' + urlCustomerId);
          this.showDetails = false;
        }
        else {
          this.location.replaceState('tasks');
          this.showDetails = false;
        }
      }));
  }

  public ngOnDestroy(): void {
    this.store.dispatch(new ClearCurrentTaskId());
    this.subs.forEach((s) => s.unsubscribe());
  }

  public hideDetails(): void {
    this.showDetails = false;
  }
}
